import { Alert, Avatar, Box, Button, Card, CardActions, CardContent, CardHeader, Divider, Grid, IconButton, List, ListItem, ListItemAvatar, ListItemText, Modal, Typography } from "@mui/material"
import React, { useContext, useState } from "react";
import { State, StateContext } from "../../state";
import { TourCard } from "../tour/tour_card";
import { useNavigate } from "react-router";
import moment from "moment";
import { Delete } from "@mui/icons-material";
import ScrollToTop, { BackWidget, FlexDivider } from "../../widgets/utils";
import AlertDialogSlide from "../../widgets/modal";
import { RentalDetails } from "../tour/rental";
import { extraDevice } from "../../data/markersData";
import { InfoForm } from "../tour/tour_details";

const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '300px',
    maxWidth: 1000,
    bgcolor: 'background.paper',
    borderRadius: '8px',
    boxShadow: 24,
    alignItems: "center",
    gap: '24px',
    display: "flex",
    flexDirection: "column",
    padding: 2,
    border: 0
  }
  

export const Checkout = () => {

    const { chartList, removeFromChecklist, setUserInfos } = useContext(StateContext) as State;
    const navigate = useNavigate()

    const [ showDetail, setShowDetail ] = useState<boolean>(false);
    const [ deleteConfirmIndex, setShowDeleteConfirm ] = useState<any>(false);

    const _removeFromChecklist = (j: number) => {
        setShowDeleteConfirm(j)
    }

    const setTall = (pack: any, itemIndex: any, tall: number) => {
        const _items = structuredClone(pack.items)
        _items[itemIndex].tall = tall
        pack.items = _items
    }

    const onInfoChange = (pack: any, infos: any) => {
        pack.infos = structuredClone(infos)
        setUserInfos({
            name: infos.name,
            surname: infos.surname,
            email: infos.email,
            phone: infos.phone
        })
    }

    let _chartList =  chartList.sort((a:any, b:any) => new Date(a.start).getTime() - new Date(b.start).getTime())
    let date = _chartList.reduce(function (r:any, a:any) {
        r[a.start] = r[a.start] || [];
        r[a.start].push(a);
        return r;
    }, Object.create(null));

    const total = _chartList.map((c:any) => c.total).reduce((a:any, b:any) => a + b, 0)

    return (
        <>
        <ScrollToTop />
        <BackWidget />
        <div className="container">
            <Grid container className="pad-20">
                <Grid size={{"md":8, "xs": 12}} sx={{marginBottom: "50px"}}>
                    <br/>
                    <br/>
                    <Typography variant="h4" className="row gap-40">Carrello <Typography variant="subtitle1">
                        <b>Tour:</b> {_chartList.length}
                    </Typography>
                    <Typography variant="subtitle2">
                        <b>Totale: </b> {total}€
                    </Typography></Typography>
                    
                    <br/>
                    <div className="col gap-40" style={{ marginBottom: 40}}>
                        {Object.keys(date).map((start: string) => (
                            <>
                                <div style={{borderBottom: '1px solid gray', width: '80%', marginTop: 40}}/>
                                <Typography variant="h5">{moment(start).format("DD MMMM")}
                                {date[start].length > 1 &&
                                    <Alert severity="warning" style={{maxWidth: '560px'}}>Attenzione hai {date[start].length} tour per il {moment(start).format("DD MMMM")}</Alert>
                                }
                                </Typography>
                                
                                {date[start].map((pack:any, j: number) => (
                                    <div className="card card-checkout">
                                        <List sx={{ width: '100%', bgcolor: 'background.paper' }}>
                                            <ListItem alignItems="flex-start">
                                                <ListItemText
                                                    primary={
                                                        <React.Fragment>
                                                            <Typography variant="h4" className="checkout-title row gap-20">
                                                                Totale <b>{pack.total} €</b> &nbsp;
                                                                <FlexDivider/>
                                                                <IconButton onClick={() => _removeFromChecklist(j)}><Delete color="error"/></IconButton>
                                                            </Typography>
                                                            
                                                        </React.Fragment>
                                                    }
                                                />
                                            </ListItem>
                                        </List>
                                        <Typography variant="h5">Data di validità</Typography>
                                        <br/>
                                        <Typography className="badge">{moment(pack.start).format("DD MMMM")} {pack.tour.routes.length > 1 ? ` - ${moment(pack.end).subtract(1, 'day').format("DD MMMM")}`: ''}</Typography>
                                        <br/>
                                        <Typography variant="h5">Numero di partecipanti</Typography>
                                        <br/>
                                        <Typography className="badge">{pack.person} partecipant{pack.person === 1 ? 'e': 'i'}</Typography>
                                        <br/>
                                        <Typography variant="h5">
                                            Tour selezionato
                                        </Typography>
                                        <br/>
                                        <TourCard tour={pack.tour} horizontal onTourClick={() => navigate(`tour/${pack.tour.id}`, {state: { disabled: true }})} />
                                        <br/>
                                        <Typography variant="h5">
                                            Oggetti a noleggio per questo tour
                                        </Typography>
                                        {pack.items.length === 0 &&
                                            <>
                                                <br />
                                                <Typography variant="subtitle2">Nessun oggetto a noleggio</Typography>
                                            </>
                                        }
                                        <List sx={{ width: '100%', bgcolor: 'background.paper' }}>
                                            <RentalDetails catalogue={[...extraDevice, ...pack.tour.catalogue]} items={pack.items} readonly days={moment(pack.end).diff(moment(pack.start), "d")} checkoutMode />
                                        </List>
                                        {pack.infos &&
                                            <div>
                                                {!pack.infos.email &&
                                                    <Typography variant="h5">Inserisci le informazioni mancanti</Typography>
                                                }
                                                {pack.infos.email &&
                                                    <Typography variant="h5">Informazioni personali</Typography>
                                                }
                                                <br/>
                                                <InfoForm items={pack.items} onChange={(infos: any) => onInfoChange(pack, infos)} onTallChange={(i:any, j:any) => setTall(pack, i, j)} />
                                            </div>
                                        }
                                    </div>
                                ))}
                            </>
                    ))}
                    </div>
                </Grid>
                <Grid size={showDetail ? 12 : 4} sx={{ display: { xs: showDetail ? 'block' : 'none', md: 'block' } }}>
                    <Card className="card-checkout card col checkout-fixed">
                        <CardHeader title="Resoconto"/>
                        <CardContent style={{ flex: 1}}>
                            <Typography variant="h5">
                                <b>Tour:</b> {_chartList.length}
                            </Typography>
                            <br/>
                            <Typography variant="h5">
                                <b>Totale: </b> {total}€
                            </Typography>
                        </CardContent>
                        <CardActions>
                            {showDetail &&
                                <Button variant="outlined"  color="warning" size="large" className="fullwidth" onClick={() => setShowDetail(false)}>Indietro</Button>
                            }
                            <PayButton 
                                title={"Completa l'acquisto"}
                                amount={total} 
                                currency={'eur'}
                                data={_chartList}
                                disabled={_chartList.length === 0} 
                            />
                        </CardActions>
                    </Card>
                </Grid>
            </Grid>
            <Grid container sx={{ display: { xs: !showDetail ? 'block': 'none', md: 'none' } }} className="bottom-bar-fixed">
                <Grid size={12}>
                  <Button variant="contained" size="large" className="fullwidth" onClick={() => setShowDetail(true)}>Procedi</Button>
                </Grid>
            </Grid> 
            <Modal
                open={deleteConfirmIndex !== false}
                onClose={() => setShowDeleteConfirm(false)}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={modalStyle} className="no-outline">
                    <Typography>Sei sicuro di voler rimuovere dal carrello questo tour e i noleggi ad esso legati?</Typography>
                    <div className="row fullwidth gap-20">
                        <Button variant="outlined" color="info" className="fullwidth" onClick={() => { setShowDeleteConfirm(false)}}>No, anulla</Button>
                        <Button variant="contained" color="warning" className="fullwidth" onClick={() => {
                            removeFromChecklist(deleteConfirmIndex); 
                            setShowDeleteConfirm(false)
                        }}>Si</Button>
                    </div>
                </Box>
          </Modal>
        </div>
        </>
    )
}

export const PayButton = ({title, disabled, amount, currency, data}: any) => {

    const navigate = useNavigate()

    const onclick = () => {
        //  arrotondo le altezze
        data.items.forEach((item: any) => {
          if(item.tall) {
            item.tall = Math.round(item.tall)
          }  
        })
        console.log("DATA", data)
        navigate('payment', {state : {amount, currency, data}})
    }

    return (
        <Button 
            variant="contained" 
            size="large"
            sx={{ borderRadius: "25px", width: {md: 200, xs: '100%'}}}
            onClick={() => onclick()}
            color="success"
            disabled={disabled}
        >
       {title}
      </Button>
    )
}